import { FormModel } from '~/models/form-model';
import { InsertResult } from '~/models/insert-result';
/**
 * This should correspond to the Java class au.com.finsyn.acuritywebserver.core.api.EntityInsertUpdateResult
 * Do not change properties and keep them synchronized with backend class
 */
export interface InsertUpdateResult {
	updateResultList?: FormModel[];
	insertResultList?: InsertResult[];
}

export function isInsertUpdateResult(
	object: any,
): object is InsertUpdateResult {
	return object.updateResultList || object.insertResultList;
}
